import { useReducer } from 'react';
import { defaultValues, reducer, TYPES } from '../state/reducer';

const useCrossOut = () => {
  const [state, dispatch] = useReducer(reducer, defaultValues);
  const dispatchers = {
    toggleCrossOut: () => {
      dispatch({
        type: TYPES.TOGGLE_CROSSOUT,
      });
    },
    enableCrossOut: () => {
      dispatch({
        type: TYPES.ENABLE_CROSSOUT,
      });
    },
    setDefaultToggleCrossOutCount: (toggleCount) => {
      dispatch({
        type: TYPES.TOGGLE_CROSSOUT_COUNT,
        payload: {
          toggleCount,
        },
      });
    },
    increaseToggleCrossOutCount: () => {
      const newCount = state.toggleCount + 1;
      dispatch({
        type: TYPES.TOGGLE_CROSSOUT_COUNT,
        payload: {
          toggleCount: newCount,
        },
      });

      return newCount;
    },
    doInit: () => {
      dispatch({
        type: TYPES.SET_INIT,
      });
    },
    setCrossedOutByRefCount: (reference, canAdd) => {
      dispatch({
        type: TYPES.SET_CROSSEDOUT_BY_REFERENCE,
        payload: {
          reference,
          type: canAdd ? 'add' : 'remove',
        },
      });
    },
    resetCrossedOutByRefCount: (reference) => {
      dispatch({
        type: TYPES.RESET_CROSSEDOUT_BY_REFERENCE,
        payload: {
          reference,
        },
      });
    },
  };

  return [state, dispatchers];
};

export default useCrossOut;
